/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LogEntry } from './LogEntry';
import {
    LogEntryFromJSON,
    LogEntryFromJSONTyped,
    LogEntryToJSON,
    LogEntryToJSONTyped,
} from './LogEntry';

/**
 * 
 * @export
 * @interface Domain
 */
export interface Domain {
    /**
     * 
     * @type {number}
     * @memberof Domain
     */
    readonly id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Domain
     */
    readonly tags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    readonly technologies: string;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    readonly findingsStats: string;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    readonly subdomainsCount: string;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    readonly ports: string;
    /**
     * 
     * @type {Array<LogEntry>}
     * @memberof Domain
     */
    readonly history: Array<LogEntry>;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    readonly latestScan: string;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    riskScore?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Domain
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Domain
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Domain
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    domainName: string;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    registrar?: string;
    /**
     * 
     * @type {Date}
     * @memberof Domain
     */
    registrationDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Domain
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {any}
     * @memberof Domain
     */
    dnsRecords?: any | null;
    /**
     * 
     * @type {any}
     * @memberof Domain
     */
    whoisRecords?: any | null;
    /**
     * 
     * @type {any}
     * @memberof Domain
     */
    tlsCertificate?: any | null;
    /**
     * 
     * @type {number}
     * @memberof Domain
     */
    team: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Domain
     */
    readonly ipAddresses: Array<number>;
}

/**
 * Check if a given object implements the Domain interface.
 */
export function instanceOfDomain(value: object): value is Domain {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tags' in value) || value['tags'] === undefined) return false;
    if (!('technologies' in value) || value['technologies'] === undefined) return false;
    if (!('findingsStats' in value) || value['findingsStats'] === undefined) return false;
    if (!('subdomainsCount' in value) || value['subdomainsCount'] === undefined) return false;
    if (!('ports' in value) || value['ports'] === undefined) return false;
    if (!('history' in value) || value['history'] === undefined) return false;
    if (!('latestScan' in value) || value['latestScan'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('domainName' in value) || value['domainName'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('ipAddresses' in value) || value['ipAddresses'] === undefined) return false;
    return true;
}

export function DomainFromJSON(json: any): Domain {
    return DomainFromJSONTyped(json, false);
}

export function DomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): Domain {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tags': json['tags'],
        'technologies': json['technologies'],
        'findingsStats': json['findings_stats'],
        'subdomainsCount': json['subdomains_count'],
        'ports': json['ports'],
        'history': ((json['history'] as Array<any>).map(LogEntryFromJSON)),
        'latestScan': json['latest_scan'],
        'riskScore': json['risk_score'] == null ? undefined : json['risk_score'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'domainName': json['domain_name'],
        'registrar': json['registrar'] == null ? undefined : json['registrar'],
        'registrationDate': json['registration_date'] == null ? undefined : (new Date(json['registration_date'])),
        'expirationDate': json['expiration_date'] == null ? undefined : (new Date(json['expiration_date'])),
        'dnsRecords': json['dns_records'] == null ? undefined : json['dns_records'],
        'whoisRecords': json['whois_records'] == null ? undefined : json['whois_records'],
        'tlsCertificate': json['tls_certificate'] == null ? undefined : json['tls_certificate'],
        'team': json['team'],
        'ipAddresses': json['ip_addresses'],
    };
}

  export function DomainToJSON(json: any): Domain {
      return DomainToJSONTyped(json, false);
  }

  export function DomainToJSONTyped(value?: Omit<Domain, 'id'|'tags'|'technologies'|'findings_stats'|'subdomains_count'|'ports'|'history'|'latest_scan'|'created_at'|'updated_at'|'ip_addresses'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'risk_score': value['riskScore'],
        'is_active': value['isActive'],
        'domain_name': value['domainName'],
        'registrar': value['registrar'],
        'registration_date': value['registrationDate'] == null ? undefined : ((value['registrationDate'] as any).toISOString().substring(0,10)),
        'expiration_date': value['expirationDate'] == null ? undefined : ((value['expirationDate'] as any).toISOString().substring(0,10)),
        'dns_records': value['dnsRecords'],
        'whois_records': value['whoisRecords'],
        'tls_certificate': value['tlsCertificate'],
        'team': value['team'],
    };
}

